module.exports = __webpack_public_path__ + "static/chytra-53644c8f93018d5d8b91d1eaeef495e9.jpg";